<soft-query-bar-item [value]="value()"
                     [icon]="'fa-regular fa-calendar-range'"
                     [title]="title()"
                     (click)="onClick()">
  <ng-template let-value="value">
    <div class="text-xs text-nowrap">
      {{value?.from | format:'DATE.DEFAULT'}} -
      {{value?.to | format:'DATE.DEFAULT'}}
    </div>
  </ng-template>
</soft-query-bar-item>
